import { render, staticRenderFns } from "./SwitchTwoLabel.vue?vue&type=template&id=346a7e40&scoped=true&"
import script from "./SwitchTwoLabel.vue?vue&type=script&lang=js&"
export * from "./SwitchTwoLabel.vue?vue&type=script&lang=js&"
import style0 from "./SwitchTwoLabel.vue?vue&type=style&index=0&id=346a7e40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346a7e40",
  null
  
)

export default component.exports